// Converts the MUI `sx`-style objects that existing screens pass (buttonStyle, inputStyle, style, custom)
// into plain inline styles, so the Tailwind components honour simple layout tweaks.
// Handles spacing shorthands (m, mt, px, …: numbers are 8px units), `bgcolor`, and responsive objects
// ({ xs, md } → the md/sm/xs value). Nested selectors ("&:hover", "& input", "path") are dropped.
const SPACING = {
  m: ["margin"],
  mt: ["marginTop"],
  mb: ["marginBottom"],
  ml: ["marginLeft"],
  mr: ["marginRight"],
  mx: ["marginLeft", "marginRight"],
  my: ["marginTop", "marginBottom"],
  p: ["padding"],
  pt: ["paddingTop"],
  pb: ["paddingBottom"],
  pl: ["paddingLeft"],
  pr: ["paddingRight"],
  px: ["paddingLeft", "paddingRight"],
  py: ["paddingTop", "paddingBottom"],
};
const ALIASES = { bgcolor: "backgroundColor" };

const pick = (v) => (v && typeof v === "object" && !Array.isArray(v) ? (v.md ?? v.sm ?? v.xs ?? v.lg ?? v.xl) : v);

export function sxToStyle(sx) {
  if (!sx || typeof sx !== "object" || Array.isArray(sx)) return undefined;
  const out = {};
  for (const [key, raw] of Object.entries(sx)) {
    if (/^[&:@.]/.test(key) || key === "path" || key === "svg") continue;
    const value = pick(raw);
    if (value === undefined || value === null || value === false || typeof value === "object") continue;
    if (SPACING[key]) {
      const css = typeof value === "number" ? `${value * 8}px` : value;
      SPACING[key].forEach((k) => (out[k] = css));
    } else {
      out[ALIASES[key] || key] = value;
    }
  }
  return Object.keys(out).length ? out : undefined;
}
